// src/components/ConfirmAccount.jsx

import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './LoginScreen.css'; // ✅ reuse shared styles

export default function ConfirmAccount() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  useEffect(() => {
    const confirm = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/confirm-account/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uidb64: uid, token }),
        });

        const data = await res.json();
        if (res.ok && data.success) {
          setStatus('success');
          setTimeout(() => navigate('/'), 2000);
        } else {
          setStatus('error');
        }
      } catch (err) {
        setStatus('error');
      } finally {
        setLoading(false);
      }
    };

    if (uid && token) confirm();
    else setStatus('error');
  }, [uid, token, navigate]);

  return (
    <div className="login-wrapper">
      <div className="login-screen">
        <h2>Confirming Your Account…</h2>

        <p className="register-link">
          {loading && <span>Processing confirmation…</span>}
          {status === 'success' && <span className="success-message">Account confirmed. Redirecting…</span>}
          {status === 'error' && <span style={{ color: 'red' }}>Invalid or expired confirmation link.</span>}
        </p>
      </div>
    </div>
  );
}
